export function parseAuthFromUrl(href: string) {
  const u = new URL(href);
  const hash = u.hash.startsWith('#') ? u.hash.slice(1) : u.hash;
  const hashParams = new URLSearchParams(hash);
  const qs = u.searchParams;

  const fromHash = {
    access_token: hashParams.get('access_token') || '',
    refresh_token: hashParams.get('refresh_token') || '',
    type: hashParams.get('type') || '',
  };

  const fromQuery = {
    code: qs.get('code') || '',
  };

  return { fromHash, fromQuery, raw: { hash, search: u.search } };
}
